import React, { useState } from "react";
import { useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import styles from "./Jobdetails.module.css";
import Breadcrumbs, { BreadcrumbsItem } from "@atlaskit/breadcrumbs";
import { useNavigate } from "react-router-dom";
import { errorHandler } from "../../helpers/helpers";

import Spinner from "@atlaskit/spinner";
import EmojiFrequentIcon from "@atlaskit/icon/glyph/emoji/frequent";
import ChevronLeftCircleIcon from "@atlaskit/icon/glyph/chevron-left-circle";
import Button from "@atlaskit/button";
import { UseToast } from "../../components/context/ToastContext";
import { API } from "../../utility/Api";

import RefreshIcon from "@atlaskit/icon/glyph/refresh";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { jobStatus, jobTypes } from "../../constants/constants";
import BackupIssueJobDetails from "../../components/Jobdetails/BackupIssueJobDetails";
import BackupConfigJobDetails from "../../components/Jobdetails/BackupConfigJobDetails";
import MainJobDetails from "../../components/Jobdetails/MainJobDetails";
import RestoreIssuesJobDetails from "../../components/Jobdetails/RestoreIssuesJobDetails";
import RestoreConfigJobDetails from "../../components/Jobdetails/RestoreConfigJobDetails";
import FiltersModal from "../../components/Jobdetails/FiltersModal/FiltersModal";

const JobDetails = () => {
  const location = useLocation();

  const whereAmI = location.pathname.split("/")[1];

  const [searchParams, setSearchParams] = useSearchParams();

  const { setMainMessage } = UseToast();

  const navigate = useNavigate();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [jobDetails, setJobDetails] = useState({});
  const [moreJobDetails, setMoreJobDetails] = useState([]);
  const [screensMetadata, setScreensMetadata] = useState({});
  const [workflowsMetadata, setworkflowsMetadata] = useState({});
  const [refresh, setRefresh] = useState(true);
  const [totalPages, setTotalPages] = useState();
  const [pagination, setPagination] = useState({
    page: "1",
    size: 10,
  });
  const [jobToGoTo, setJobToGoTo] = useState(searchParams.get("id"));
  const [userName, setUserName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [restoreIssuesDetails, setRestoreIssuesDetails] = useState([]);
  const [restoreConfigDetails, setRestoreConfigDetails] = useState([]);

  const getRestoreIssueDetails = async (token) => {
    setLoading(true);
    await API.get(`api/restore_issues_jobdetails?jobId=${jobToGoTo}`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setRestoreIssuesDetails(response.data.restoreIssuesJobdetails);
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setLoading(false);
      });
  };
  const getRestoreConfigDetails = async (token) => {
    setLoading(true);
    await API.get(`api/restore_config_jobdetails?jobId=${jobToGoTo}`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setRestoreConfigDetails(response.data.restoreConfigJobdetails);
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setLoading(false);
      });
  };

  const getBackupIssuesJobDetails = async (token) => {
    setLoading(true);
    await API.get(
      `api/backup_issues_jobdetails?jobId=${jobToGoTo}&page=${pagination.page}&size=${pagination.size}`,
      {
        headers: {
          Authorization: `JWT ${token}`,
        },
      }
    )
      .then(function (response) {
        setTotalPages(response.data.totalProjectsCount);
        setMoreJobDetails(response.data.projectsMetadata);

        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setLoading(false);
      });
  };
  const getBackupConfigJobDetails = async (token) => {
    setLoading(true);
    await API.get(`api/backup_config_jobdetails?jobId=${jobToGoTo}`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setScreensMetadata(response.data.screenDetails);
        setworkflowsMetadata(response.data.workflowDetails);
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setLoading(false);
      });
  };

  useEffect(() => {
    // eslint-disable-next-line no-undef
    AP.context.getToken(function (token) {
      whereAmI === "backup"
        ? //backup
          searchParams.get("type") === "Issues"
          ? // issues details
            getBackupIssuesJobDetails(token)
          : // config details
            getBackupConfigJobDetails(token)
        : //restore
        searchParams.get("type") === "Issues" ||
          searchParams.get("type") === "Quick"
        ? //  issue details
          getRestoreIssueDetails(token)
        : // config details
          getRestoreConfigDetails(token);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, jobToGoTo, pagination]);
  const onPaginationChange = (e, page) => {
    setPagination((prevState) => ({
      page: page,
      size: prevState.size,
    }));
  };

  return (
    <div className={styles.JobDetailsContainer}>
      <div className={styles.nonfootercontainer}>
        <div className={styles.topbarcontainer}>
          <div className={styles.aligncenter}>
            <Link to={`/${whereAmI}/jobs`}>
              <ChevronLeftCircleIcon />
            </Link>
            &nbsp;
            <Breadcrumbs>
              <BreadcrumbsItem
                onClick={() => navigate(`/${whereAmI}/jobs`)}
                text="Jobs"
              />
              {isLoading ? (
                <Skeleton width="25px" />
              ) : (
                <BreadcrumbsItem text={"ID : " + jobDetails.id} />
              )}
            </Breadcrumbs>
          </div>
          <div className={styles.pagetitle}>Job details</div>
          <div className={styles.secondarytext}>
            <EmojiFrequentIcon />
            Last Updated at :&nbsp;{" "}
            {isLoading ? (
              <Skeleton width="300px" />
            ) : (
              moment().format("ddd ,DD MMM YYYY hh:mm:ss ")
            )}
            <Button
              appearance="subtle"
              onClick={() => setRefresh((prev) => !prev)}
              iconBefore={<RefreshIcon size="medium" />}
              style={{ display: "flex", alignItems: "center" }}
            ></Button>
          </div>
        </div>

        <MainJobDetails
          whereAmI={whereAmI}
          isLoading={isLoading}
          jobDetails={jobDetails}
          setJobDetails={setJobDetails}
          searchParams={searchParams}
          userName={userName}
          avatar={avatar}
          totalPages={totalPages}
          refresh={refresh}
          jobToGoTo={jobToGoTo}
          setShowFilterModal={setShowFilterModal}
        />
        {isLoading ? (
          <Spinner />
        ) : whereAmI === "restore" ? (
          // ////////////////////////////////////////////////////
          // RESTORE SECTION
          // ////////////////////////////////////////////////////
          searchParams.get("type") === "Quick" ||
          searchParams.get("type") === "Issues" ? (
            // ##########################
            //                  ISSUES
            // #########################
            <div className={styles.restoreissuejobdetailscontainer}>
              <RestoreIssuesJobDetails
                restoreIssuesDetails={restoreIssuesDetails}
                isLoading={isLoading}
                refresh={refresh}
                jobType={searchParams.get("type")}
              />
            </div>
          ) : searchParams.get("type") === "Configuration" ? (
            // ##########################
            //                  Configs
            // #########################
            <div className={styles.restoreconfigjobdetailscontainer}>
              <RestoreConfigJobDetails
                restoreConfigDetails={restoreConfigDetails}
                isLoading={isLoading}
                refresh={refresh}
              />
            </div>
          ) : (
            <Spinner />
          )
        ) : // ////////////////////////////////////////////////////
        // BACKUP SECTION
        // ////////////////////////////////////////////////////
        jobStatus[jobDetails.status] === "Queued" ? (
          //##########################
          // queued job
          // #########################
          <h5 style={{ color: "grey", opacity: "0.5" }}>
            Job is queued , more details will appear when job starts
          </h5>
        ) : jobTypes[jobDetails.type] === "Issues" ? (
          // ##########################
          //                  Issues
          // #########################
          <BackupIssueJobDetails
            moreJobDetails={
              searchParams.get("type") === "Issues" ? moreJobDetails : []
            }
            isLoading={isLoading}
            totalPages={totalPages}
            pagination={pagination}
            onPaginationChange={onPaginationChange}
          />
        ) : jobDetails.type === 1 ? (
          // ##########################
          //                  Configs
          // #########################
          <BackupConfigJobDetails
            jobStatus={jobStatus}
            screensMetadata={screensMetadata}
            isLoading={isLoading}
            workflowsMetadata={workflowsMetadata}
          />
        ) : (
          // #########################
          <Spinner />
        )}
      </div>
      <FiltersModal
        showFilterModal={showFilterModal}
        setShowFilterModal={setShowFilterModal}
        whereAmI={whereAmI}
        jobToGoTo={jobToGoTo}
        jobType={searchParams.get("type")}
      />
      {/* <div className={styles.footercontainer}>
        <Tooltip
          content={
            jobDetails.id === 1 ? "First Job reached" : "Go to previous job"
          }
        >
          <Button
            isDisabled={isLoading || jobDetails.id === 1}
            iconBefore={<ChevronLeftCircleIcon />}
            appearance="subtle"
            onClick={() => setJobToGoTo(jobDetails.id - 1)}
          >
            Previous Job
          </Button>
        </Tooltip>

        <Tooltip
          content={
            String(jobDetails.id) === String(searchParams.get("totalJobs"))
              ? "Last job reached"
              : "Go to next job"
          }
        >
          <Button
            isDisabled={
              isLoading ||
              String(jobDetails.id) === String(searchParams.get("totalJobs"))
            }
            iconAfter={<ChevronRightCircleIcon />}
            appearance="subtle"
            onClick={() => setJobToGoTo(jobDetails.id + 1)}
          >
            Next Job
          </Button>
        </Tooltip>
      </div> */}
    </div>
  );
};

export default JobDetails;
